import React from 'react';
import './personelCard.css'
import {Col, Container, Image, Row} from "react-bootstrap";
import {Link} from "react-router-dom";

function PersonnelCard({image,email,linkedin,gitlab,name,specialization}) {
    return (
        // <Container>
        //     <Row className={'column-gap-5'}>
        //         <Col lg={3}>
        <div className={'personnel-card-wrapper'}>
            <div className="personnel-card-image">
                <Image src={image}/>
                <div className={'social-icons-wrapper'}>
                    <div className={'social-icons-row'}>
                        <Link to={linkedin} className={'social-icon-wrapper'}>
                            <i className="fa-brands fa-linkedin-in"></i>
                        </Link>
                        <Link to={gitlab} className={'social-icon-wrapper'}>
                            <i className="fa-brands fa-gitlab"></i>
                        </Link>
                        <Link to={email} className={'social-icon-wrapper'}>
                            <i className="fa-solid fa-envelope"></i>
                        </Link>
                    </div>
                </div>
            </div>
            <h4>{name}</h4>
            <p>{specialization}</p>
        </div>
    );
}

export default PersonnelCard;